/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/Homepage`, `src/app/BasePage`).
 */

 import React from "react";
 import {
   Switch,
   Route,
   useLocation,
   useHistory,
 } from "react-router-dom";
 import { shallowEqual, useDispatch, useSelector } from "react-redux";
 import { Layout } from "../_metronic/layout";
 import BasePage from "./BasePage";
 import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";
 import { actions } from "./modules/SearchPage/_redux/searchRedux";
 import { actions as authActions } from "./modules/Auth/_redux/authRedux";
 
 export function Routes(props) {
 
 
   const state = useSelector((state) => state.townships);
   const dispatch = useDispatch();
 
   React.useEffect(() => {
     const tokenExpireTime = localStorage.getItem("tokenExpireTime");
 
     if (JSON.parse(tokenExpireTime)) {
       const OBJ = JSON.parse(tokenExpireTime);
 
       if (new Date() < new Date(OBJ.date)) {
         dispatch(
           actions.setUser(
             JSON.parse(window.localStorage.getItem("userInformation"))
           )
         );
         dispatch(actions.setTokenStatus(false));
       } else {
         dispatch(authActions.login(null));
         dispatch(actions.setTokenStatus(true));
       }
     }
   }, []);
 
   const history = useHistory();
 
   React.useEffect(() => {
 
     const pageSubject = history.location.pathname.split("/");
 
     if (pageSubject[1] && pageSubject[1].toLowerCase() === "faq") {
 
       document.title = `سوالات متداول - پرسش های متداول اتوبوسی| ایباس`;
 
     } else if (pageSubject[1] && pageSubject[1].toLowerCase() === "why-ebus") {
 
       document.title = "چرا اتوبوس ایباس | ایباس";
 
 
 
 
 
     } else if (pageSubject[1] && pageSubject[1].toLowerCase() === "aboutus") {
       document.title = `درباره ما | ایباس`;
 
 
 
 
     } else if (pageSubject[1] === "ComingSoon") {
 
       document.title = "ایباس به زودی | ایباس";
 
     } else if (pageSubject[1] && pageSubject[1].toLowerCase() === "contact-us") {
       document.title = "پشیتبانی و راه های ارتباطی | ایباس";
 
 
     } else if (pageSubject[1] && pageSubject[1].toLowerCase() === "ebus-customer-rules") {
 
       document.title = "امور مشتریان | ایباس";
 
     } else if (pageSubject[1] && pageSubject[1].toLowerCase() === "passenger-rules") {
       document.title = "حقوق مسافر اتوبوسی | ایباس";
     } else if (
       pageSubject[1] && pageSubject[1].toLowerCase() === "ebus-charter"
     ) {
       document.title = `اتوبوس دربستی - کرایه اتوبوس دربستی به همه جا| ایباس`;
     } else if (pageSubject[1] === "Extradition") {
 
       console.log("FUCKKKKKKKKKKKKKKKKKKKKK============", pageSubject[1])
 
       document.title = `استرداد بلیط اتوبوس- نحوه استرداد بلیط اتوبوس| ایباس`;
     } else if (pageSubject[1] && pageSubject[1].toLowerCase() === "CulturalRules") {
 
       document.title = " فوانین فرهنگی سفر | ایباس";
 
     }
 
 
     else if (pageSubject[1] && pageSubject[1].toLowerCase() === "OTBus") {
       document.title = "حرکت  به موقع اتوبوس | ایباس"
 
 
     } else if (pageSubject[1] && pageSubject[1].toLowerCase() === "owner-contract") {
 
       document.title = "سامانه ثبت مالکین | سامانه هوشمند حمل و نقل";
     } else if (
       pageSubject[1] === "jobs-opportunities"
     ) {
       document.title = `فرصت های شغلی - آگهی استخدام| ایباس`;
 
     } else if (pageSubject[1] && pageSubject[1].toLowerCase() === "bus-ticket") {
       {state.srcAndDestTitle?
         document.title = `بلیط اتوبوس ${state.srcAndDestTitle.source.persianTitle} ${state.srcAndDestTitle.dest.persianTitle} - قیمت بلیط + ساعت حرکت | ایباس`:
         document.title = `بلیط اتوبوس - قیمت بلیط + ساعت حرکت| ایباس`;
       }
     } else {
       document.title =
       `بلیط اتوبوس - رزرو بلیط اتوبوس:خرید بلیط اتوبوس| ایباس `
     }
 
 
   });
 
   // console.log("state", state);
 
   let location = useLocation();
 
   return (
     <Switch>
       <Layout>
         <BasePage />
       </Layout>
 
       <Route path="/error" component={ErrorsPage} />
     </Switch>
   );
 }
 